import { __awaiter } from "tslib";
import EventEmitter from 'events';
export class EventsMap {
    constructor(logger) {
        this.registered = new Map();
        this.logger = logger;
    }
    store(eventName, handler) {
        var _a;
        if (!this.registered.has(eventName)) {
            this.registered.set(eventName, new EventEmitter());
        }
        (_a = this.registered.get(eventName)) === null || _a === void 0 ? void 0 : _a.on(eventName, (event) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield handler(event);
            }
            catch (error) {
                this.logger.error(`Error in handler for event ${eventName}`, error);
            }
        }));
    }
    load(eventName) {
        return this.registered.get(eventName);
    }
}
